import { useMutation } from '@tanstack/react-query';
import { call, upload } from '@/lib/apiClient';
import type { StandardizeInput, StandardizeResult, UploadResult } from '@/lib/types';

export const standardizeApi = {
  standardize: (input: StandardizeInput) =>
    call<StandardizeResult>('/standardize', { method: 'POST', body: JSON.stringify(input) }),
  uploadDraft: (file: File) => {
    const fd = new FormData();
    fd.append('file', file);
    return upload<UploadResult>('/standardize/upload', fd);
  },
  getAdeFallbackStatus: (uploadId: string) =>
    call<{ status: 'processing' | 'done' | 'failed'; markdown?: string; error?: string }>(`/standardize/ade-fallback-status/${uploadId}`, { method: 'GET' }),
};

export function useStandardize() {
  return useMutation({ mutationFn: standardizeApi.standardize });
}

export function useUploadDraft() {
  return useMutation({ mutationFn: standardizeApi.uploadDraft });
}
